<template>
  <div>
    <!-- <div id="content" class="colM">
      <h1>{{$t('registration.password_reset_title')}}</h1>
      <p>{{$t('registration.password_reset_content')}}</p>

      <form method="post" @submit.prevent="passwodReset">
        <div class="row form-row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <label>{{$t('registration.password_reset_email_or_ser')}}:</label>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12">
            <input type="text" maxlength="254" required="" v-model="email_or_username" style="width:100%;">
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary btn-flat">{{$t('registration.reset_btn')}}</button>
            <button class="btn btn-default btn-flat pull-right" @click="cancelPasswodReset">{{$t('common.cancel')}}</button>
          </div>
        </div>
      </form>
      <br class="clear">
    </div> -->
    <div>
      <div class="">
        <h2
          class="heading-w3-agile"
          style="text-align:center; color:black; font-weight: 200; text-transform: uppercase;"
        >
          {{ $t("registration.password_reset_title") }}
        </h2>
        <p class="heading-w3-agile" style="margin-bottom: 15px;">
          {{ $t("registration.password_reset_content") }}
        </p>
        <form method="post" @submit.prevent="passwodReset">
          <div class="inputs-w3ls">
            <p style="color:black;">
              {{ $t("registration.password_reset_email_or_ser") }}:
            </p>
            <i class="fa fa-envelope" aria-hidden="true"></i>
            <input
              type="text"
              class="email"
              name="Email"
              :placeholder="$t('registration.password_reset_email_or_ser')"
              required=""
              v-model="email_or_username"
            />
          </div>
          <label class="anim" style="padding-bottom: 15px;">
            <a @click="cancelPasswodReset" style="color:black; cursor: pointer;">{{
              $t("common.callBackLogin")
            }}</a>
          </label>
          <input type="submit" :value="$t('registration.reset_btn')" />
        </form>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Enum from "../../../enum/enum";
import Loading from "vue-loading-overlay";
// import utils from '@/lib/utils'

export default {
  name: "PasswordReset",
  data() {
    return {
      email_or_username: null,
      basepath: "",
      isLoading: false
    };
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ACCOUNT_PASSWORD_RESET"
    ]),
    passwodReset: function() {
      let payload = {
        email_or_username: this.email_or_username,
        domain: Enum.domain
      };
      this.isLoading = true
      this.ACCOUNT_PASSWORD_RESET(payload)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.$router.push({ name: "PasswordResetDone" });
            this.isLoading = false
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    cancelPasswodReset: function() {
      this.$router.push({
        name: "Login"
      });
    }
  },
  components: {
    loading: Loading
  },
  mounted() {
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "login-page hold-transition";
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/login_style.css";
@import "font-awesome/css/font-awesome.min.css";

.form-row {
  overflow: hidden;
  padding: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}

h1 {
  margin: 0 0 20px;
  font-weight: 300;
  font-size: 20px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/Account/PasswordReset.vue